import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'filterByCode',
})
export class FilterByCodePipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }
    return items.filter((item) =>
      item.code.toLowerCase().includes(searchText.toLowerCase()),
    );
  }
}
